import React, { Component } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import RegistrationProviderChartStackedV2 from './RegistrationProviderChartStackedV2';

// TODO
// Error handle
// loading spinner
// possibly remove tools

class RegistrationProviderChartStackedV2Show extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        loading:true,
      };
    }
    
    componentDidMount(){
        console.log("Loaded");
    }

    render() {
        return (
            <>
                <Row style={{height:"100vh",paddingRight:"0",paddingLeft:"0"}}>
                    <Col>
                        <Card>
                            <div style={{padding:"10pt"}}>
                                <RegistrationProviderChartStackedV2 type="area" height="96vh" maxHeight="96vh"></RegistrationProviderChartStackedV2>            
                            </div>
                        </Card>
                    </Col>
                </Row>
            </>
        );
    }
}

export default RegistrationProviderChartStackedV2Show;